import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function FinalCTA() {
  return <section id="contacto" className="py-32 bg-pearl relative overflow-hidden" data-id="element-10">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1A1A1A 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-11" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-13">
          <div className="w-20 h-20 mx-auto bg-white rounded-full shadow-lg flex items-center justify-center mb-10 border border-gray-100" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/hvr54fUgpvRXPZnwmrPfcj/grandtown_logo.jpg" alt="Grand Town Icon" className="w-12 h-12 object-contain rounded-md" data-id="element-15" />
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair text-charcoal mb-8 leading-tight" data-id="element-16">
            ¿Listo para elevar el estándar de su{' '}
            <span className="italic text-gold" data-id="element-17">inversión?</span>
          </h2>

          <p className="text-lg md:text-xl text-charcoal/70 mb-12 max-w-2xl mx-auto font-light" data-id="element-18">
            Hablemos hoy mismo sobre cómo podemos transformar la administración
            de su propiedad y maximizar su rentabilidad.
          </p>

          <a href="https://wa.me/529843115669?text=Hola%21%20Me%20gustaria%20contactar%20a%20un%20asesor" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-4 bg-[#25D366] hover:bg-[#20bd5a] text-white px-10 py-5 rounded-full text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-19">
            <MessageCircle size={24} className="group-hover:scale-110 transition-transform" data-id="element-20" />
            Contactar vía WhatsApp
          </a>

          <p className="mt-8 text-sm text-charcoal/50 uppercase tracking-widest font-medium" data-id="element-21">
            Respuesta en menos de 2 horas
          </p>
        </motion.div>
      </div>
    </section>;
}